import React from 'react';
import styled from 'styled-components';
import { Nav } from '@catalogo/core-nav';

const ButtonUI = styled(Nav)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 45px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: normal;
  color: ${({ theme }) => theme.primaryColor};
  border: 2px solid ${({ theme }) => theme.primaryColor};
  text-transform: ${({ theme }) => theme.btnTextTransform};
  font-weight: ${({ theme }) => theme.btnTextWeigth};
  cursor: pointer;

  & :hover {
    color: ${({ theme }) => theme.primaryColor};
  }
`;

const Title = styled.p`
  font-size: 16px;
  margin: 5px 0 23px;
  font-weight: 700;
  color: ${({ theme }) => theme.textColor};
  font-weight: ${({ theme }) => theme.fontWeight.title};
`;

export const MakeQuestions = ({ hasQuestions, hasOffers, hasCustomerQuestions, titleMakeQuestions, productId }) => {
  if (!hasQuestions || !hasOffers || hasCustomerQuestions) {
    return null;
  }

  return (
    <>
      <Title>{titleMakeQuestions}</Title>
      <ButtonUI to={`/perguntar/${productId}`}>Escrever pergunta</ButtonUI>
    </>
  );
};

export default MakeQuestions;
